// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"0f3cdcac","507":"b1d60be8","701":"114b8963","970":"0a98692c"}[chunkId] + ".chunk.css";
};